import { render, staticRenderFns } from "./InternetDiscountPopinShared.vue?vue&type=template&id=3379b2fe&scoped=true"
import script from "./InternetDiscountPopinShared.vue?vue&type=script&lang=ts"
export * from "./InternetDiscountPopinShared.vue?vue&type=script&lang=ts"
import style0 from "./InternetDiscountPopinShared.vue?vue&type=style&index=0&id=3379b2fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3379b2fe",
  null
  
)

export default component.exports